<form [formGroup]="kycForm()" #kycFormElement>
  <h1 id="kyc-heading">Kundkännedom</h1>
  <div class="centered-container">
    <mat-progress-bar
      mode="determinate"
      [value]="currentStep * (1 / (totalSteps - 1)) * 100"
      aria-labelledby="kyc-heading"/>

    <div class="step-counter">{{ currentStep + 1 }}/{{ totalSteps }}</div>
  </div>

  @if (currentStep === KycType.BIRTH) {
    <spb-birth
      [birthForm]="getFormGroup(kycForm().controls.birthForm)"
    />
  }

  @if (currentStep === KycType.PRIMARY_RESIDENCE) {
    <spb-primary-residence
      [primaryResidenceForm]="getFormGroup(kycForm().controls.primaryResidenceForm)"
    />
  }

  @if (currentStep === KycType.GREEN_CARD) {
    <spb-green-card
      [greenCardForm]="getFormGroup(kycForm().controls.greenCardForm)"
    />
  }

  @if (currentStep === KycType.AMERICAN_CITIZENSHIP) {
    <spb-american-citizenship
      [americanCitizenshipForm]="getFormGroup(kycForm().controls.americanCitizenshipForm)"
      [kycForm]="kycForm().value"
    />
  }

  @if (currentStep === KycType.TAX_RESIDENCY) {
    <spb-tax-residency
      [taxResidencyForm]="getFormGroup(kycForm().controls.taxResidencyForm)"
      [kycForm]="kycForm().value"
    />
  }

  @if (currentStep === KycType.PEP) {
    <spb-pep
      [pepForm]="getFormGroup(kycForm().controls.pepForm)"
    />
  }

  @if (currentStep === KycType.BANK_RELATIONSHIP) {
    <spb-bank-relationship
      [latestInterest]="latestInterest"
      [bankRelationshipForm]="getFormGroup(kycForm().controls.bankRelationshipForm)"
    />
  }

  @if (currentStep === KycType.INCOME) {
    <spb-income
      [incomeForm]="getFormGroup(kycForm().controls.incomeForm)"
    />
  }

  @if (currentStep === KycType.SAVINGS) {
    <spb-savings
      [savingsForm]="getFormGroup(kycForm().controls.savingsForm)"
    />
  }

  @if (showWarningText) {
    <mat-error><p>Ange konto som pengarna ska dras ifrån eller välj att öppna
      ett sparkonto.</p></mat-error>
  }

  <div class="navigation-buttons"
       [class.small-screen]="orientationService.isSmallScreen()"
  >
    @if (currentStep !== 0) {
      <button (click)="previousStep()"
              matButton="outlined"
              [disabled]="currentStep === 0">
        Föregående
      </button>
    } @else {
      <button
        matButton="outlined"
        matStepperPrevious>
        Föregående
      </button>
    }

    @if (currentStep !== totalSteps - 1) {
      <button
        matButton="filled"
        [disabled]="!savingsAccountService.testMode() && disabledButton()"
        (click)="nextStep(kycForm().controls.bankRelationshipForm)"
      >Nästa
      </button>
    } @else {
      <button
        [disabled]="!kycForm().valid"
        matButton="filled"
        matStepperNext>
        Nästa
      </button>

    }
  </div>
</form>